import React from 'react';
import './liquidacionesModule.css';

export default function LiquidacionesFilterCard({
    children,
    actions,
    title = 'Filtros de búsqueda',
    className = ''
}) {
    return (
        <div className={`gestion-liquidaciones-filtros filter-card ${className}`.trim()}>
            <div className="gestion-liquidaciones-filtros__header">
                <h6 className="gestion-liquidaciones-filtros__title">
                    <i className="fa fa-filter" aria-hidden="true" />
                    {title}
                </h6>
            </div>
            <div className="gestion-liquidaciones-filtros__body">
                {children}
                {actions && (
                    <div className="row g-3 align-items-end mt-1">
                        <div className="col-12">
                            <div className="gestion-liquidaciones-acciones-filtro">
                                {actions}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
